<template>
  <div class="scene_add">
    <div class="left">
      <scene-round :device="b" v-for="b in devices" :key="`fan_${b.name}`" @change="(c)=>{b.checked=c}">
        <img :src="require('@/assets/images/device/fan/device_fan_e.png')" style="width:60px " slot="icon"/>
        <div class="pd20">
          <el-form label-width="60px">
            <el-form-item label="开关：">
              <div class="text-right">
                <img :src="getIcon(b.state)" class="pointer" style="width: 80px" @click="b.state=!b.state"/>
              </div>
            </el-form-item>
            <el-form-item label="风速：">
            </el-form-item>
            <div class="bt-group">
              <div @click="b.air = 1">
                <div>
                  <img :src="getAir(b.air).low"/>
                </div>
                <div>
                  <span>低风</span>
                </div>
              </div>
              <div @click="b.air = 2">
                <div>
                  <img :src="getAir(b.air).medium"/>
                </div>
                <div>
                  <span>中风</span>
                </div>
              </div>
              <div @click="b.air = 3">
                <div>
                  <img :src="getAir(b.air).high"/>
                </div>
                <div>
                  <span>高风</span>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </scene-round>
    </div>
    <div class="right">
      <el-form label-width="60px">
        <el-form-item label="开关：">
          <div class="text-right">
            <img :src="getIcon(device.state)" class="pointer" style="width: 80px" @click="device.state=!device.state"/>
          </div>
        </el-form-item>
        <el-form-item label="风速：">
        </el-form-item>
        <div class="bt-group">
          <div @click="device.air = 1">
            <div>
              <img :src="getAir(device.air).low"/>
            </div>
            <div>
              <span>低风</span>
            </div>
          </div>
          <div @click="device.air = 2">
            <div>
              <img :src="getAir(device.air).medium"/>
            </div>
            <div>
              <span>中风</span>
            </div>
          </div>
          <div @click="device.air = 3">
            <div>
              <img :src="getAir(device.air).high"/>
            </div>
            <div>
              <span>高风</span>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SceneRound from './Round'
import api from '@/model/device'
import comm from '@/assets/lib/comm'

export default {
  name: 'SceneFan',
  props: {
    command: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return { device: { state: 1, air: 2 }, copy: {}, devices: [] }
  },
  computed: {
    ...mapState(['extDevices', 'extDevicesOrign'])
  },
  components: {
    SceneRound
  },
  watch: {
    extDevices () {
      this.devices = this.extDevices.filter(d => d.devicetype.key === 'fan').map(d => {
        return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, state: this.device.state, air: this.device.air, checked: false, cmd: { ...d.cmd } }
      })
      this.syncCommand()
    },
    device: {
      deep: true,
      handler () {
        this.devices.forEach(b => {
          for (const key in this.device) {
            if (this.device[key] !== this.copy[key]) {
              b[key] = this.device[key]
            }
          }
        })
        this.copy = { ...this.device }
      }
    }
  },
  created () {
    this.devices = this.extDevices.filter(d => d.devicetype.key === 'fan').map(d => {
      return { deviceId: d.deviceId, name: d.name, sid: d.sid, nd: d.nd, state: this.device.state, air: this.device.air, checked: false, cmd: { ...d.cmd } }
    })
    this.copy = { ...this.device }
    this.$hub.$on('getCommand', this.reportCommand)
  },
  mounted () {
    // 同步一次命令
    this.syncCommand()
  },
  deactivated () {
    this.reportCommand()
  },
  methods: {
    getIcon (state) {
      if (state) {
        return require('@/assets/images/home/open.png')
      } else {
        return require('@/assets/images/home/close.png')
      }
    },
    getAir (air) {
      let icon = {
        low: require('@/assets/images/device/df.png'),
        medium: require('@/assets/images/device/zf.png'),
        high: require('@/assets/images/device/gf.png')
      }
      if (air === 1) {
        icon.low = require('@/assets/images/device/df-k.png')
      } else if (air === 2) {
        icon.medium = require('@/assets/images/device/zf-k.png')
      } else if (air === 3) {
        icon.high = require('@/assets/images/device/gf-k.png')
      }
      return icon
    },
    syncCommand () {
      this.command.forEach(c => {
        // 同步命令至当前模板
        if (this.devices.map(b => b.nd).includes(c.nd)) {
          const devices = this.devices.filter(b => b.deviceId === c.deviceId && b.nd === c.nd)
          devices.forEach(device => {
            device.checked = true
            // 找到匹配项之后，开始解析支持的命令
            const actions = JSON.parse(device.cmd.action)
            // 找到命令中包含的动作
            Object.keys(actions).forEach(name => {
              if (comm.containObject(c, actions[name])) {
                // 包含了指定的动作，那么该动存在，需要将其转换为对应的属性并进行赋值
                const obj = this.$parent.resolveAction(name, true)
                device[obj.key] = obj.value
              }
            })
          })
        }
      })
    },
    reportCommand () {
      // 同步数据
      const command = []
      this.devices.filter(d => d.checked).forEach(b => {
        // 对于多控制器的特殊处理
        let obj = this.extDevicesOrign.filter(item => item.nd === b.nd && item.deviceId !== b.deviceId)
        if (obj && obj.length) {
          obj.forEach(item => {
            command.push(Object.assign(api.generateCommand(b, b.state ? (b.air === 1 ? 'low' : b.air === 2 ? 'medium' : 'high') : 'close'), { deviceId: item.deviceId }))
          })
        } else {
          command.push(Object.assign(api.generateCommand(b, b.state ? (b.air === 1 ? 'low' : b.air === 2 ? 'medium' : 'high') : 'close'), { deviceId: b.deviceId }))
        }
        // if (b.state) {
        //   command.push(Object.assign(api.generateCommand(b, b.air === 1 ? 'low' : b.air === 2 ? 'medium' : 'high'), { deviceId: b.deviceId }))
        // } else {
        //   command.push(Object.assign(api.generateCommand(b, 'close'), { deviceId: b.deviceId }))
        // }
      })
      // debugger
      this.$emit('changeCommand', command, this.devices.filter(d => !d.checked).map(d => {
        return { deviceId: d.deviceId, nd: d.nd, sid: d.sid }
      }))
    }
  }
}
</script>

<style scoped lang="less">
.scene_add {
  margin-top: 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 0px 20px 0px 20px;
  & .bt-group {
    display: flex;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    margin-top: -20px;
    & img {
      width: 55px;
    }
  }
  > .left {
    flex: 1;
    padding-right: 30px;
    padding-top: 20px;
    width: 0;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    .pd20 {
      padding: 0px 20px;
    }
  }
  > .right {
    overflow-y: auto;
    padding-top: 20px;
    padding-left: 20px;
    width: 300px;
    border-left: 1px solid #DFE1E5;
    & .form {
      display: flex;
    }
  }
}
</style>
